import API from '../';

export const fundamentalsAPI = new API('/fundamentos');
